import { render, staticRenderFns } from "./BankListCardMobile.vue?vue&type=template&id=05b632a6&scoped=true&"
import script from "./BankListCardMobile.vue?vue&type=script&lang=js&"
export * from "./BankListCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./BankListCardMobile.vue?vue&type=style&index=0&id=05b632a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b632a6",
  null
  
)

export default component.exports